export default __webpack_public_path__ + "img/account-settings-icon-7882de3e7b673a9f12a53077c5803dde.png";